import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';

import { AtividadeServico } from '../models/atividade-servico';

@Injectable({
  providedIn: 'root',
})
export class AtividadeServicosService {
  private environmentUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore;
  }

  getAtividadeServicosAplicados(idAtividade: number): Observable<AtividadeServico[]> {
    const url = this.environmentUrl + 'atividade/' + idAtividade + '/servico';
    return this.httpClient.get<AtividadeServico[]>(url);
  }
}
